const e = "_wrapper_1wosd_1", a = "_title_1wosd_20", s = "_notAvailable_1wosd_29", t = "_notAvailableCover_1wosd_36", n = "_notAvailableMessage_1wosd_48", m = "_nameAndDistance_1wosd_56", o = "_measurementsWrapper_1wosd_64", _ = "_measurementsItem_1wosd_68", r = "_measurementsItemLabel_1wosd_82", l = "_measurementsItemValue_1wosd_85", i = "_imageWrapper_1wosd_88", p = "_chip_1wosd_93", c = "_chipLabel_1wosd_102", d = "_trailerImage_1wosd_105", w = {
  wrapper: e,
  title: a,
  notAvailable: s,
  notAvailableCover: t,
  notAvailableMessage: n,
  nameAndDistance: m,
  measurementsWrapper: o,
  measurementsItem: _,
  measurementsItemLabel: r,
  measurementsItemValue: l,
  imageWrapper: i,
  chip: p,
  chipLabel: c,
  trailerImage: d
};
export {
  p as chip,
  c as chipLabel,
  w as default,
  i as imageWrapper,
  _ as measurementsItem,
  r as measurementsItemLabel,
  l as measurementsItemValue,
  o as measurementsWrapper,
  m as nameAndDistance,
  s as notAvailable,
  t as notAvailableCover,
  n as notAvailableMessage,
  a as title,
  d as trailerImage,
  e as wrapper
};
